/**
 * Notification type keys — the single source of truth on the frontend.
 *
 * These MUST stay in sync with the backend `NotificationTypeKeys` constants
 * (Framework/Framework.DTO/NotificationTypeKeys.cs). The values are persisted on the
 * notification row and used as keys into the `componentDictionary` that maps a notification to its
 * display component. A mismatch silently falls back to the default component.
 */
export const NotificationType = {
	LessonRescheduleProposal: 'LessonRescheduleProposal',
	MissingAttendance: 'MissingAttendance',
	FinalGradeSubmissionRequired: 'FinalGradeSubmissionRequired',
	MidSemesterSurveyIncomplete: 'MidSemesterSurveyIncomplete',
	LessonGradesAvailable: 'LessonGradesAvailable',
	SemesterGradesAvailable: 'SemesterGradesAvailable',
	LessonRescheduled: 'LessonRescheduled',
	EnrollmentAssigned: 'EnrollmentAssigned',
	EnrollmentPaused: 'EnrollmentPaused',
	EnrollmentOnLeave: 'EnrollmentOnLeave',
	EnrollmentLearnerReassigned: 'EnrollmentLearnerReassigned',
	EnrollmentExtraLessons: 'EnrollmentExtraLessons',
	EnrollmentProgramChanged: 'EnrollmentProgramChanged'
} as const;

export type NotificationTypeKey = (typeof NotificationType)[keyof typeof NotificationType];

/**
 * Fallback sort weight for a notification whose type has no priority (e.g. an unknown/new type, or a
 * merged computed-feed item that has not been assigned one). Matches the backend
 * `NotificationTypeRegistry.DefaultPriority`. Sorts to the bottom.
 */
export const DEFAULT_NOTIFICATION_PRIORITY = 999;
